import {
  GET_USER_DATA,
  GET_USER_DATA_SUCCESS,
  GET_USER_DATA_ERROR,
  UPDATE_USER_SUBSCRIPTIONS,
  UPDATE_USER_SUBSCRIPTIONS_SUCCESS,
  UPDATE_USER_SUBSCRIPTIONS_ERROR,
  LOG_OUT,
} from "../constants/actionTypes";

const initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_SUBSCRIPTIONS:
    case GET_USER_DATA: {
      return {
        ...state,
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    case GET_USER_DATA_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        data: action.payload,
      };
    }


    case (UPDATE_USER_SUBSCRIPTIONS_SUCCESS): {
      return {
        ...state,
        data: {
          ...state.data,
          subscriptions: action.payload,
        },
      };
    }

    case UPDATE_USER_SUBSCRIPTIONS_ERROR:
    case GET_USER_DATA_ERROR: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };
    }

    case LOG_OUT:  {
      return {
        ...state,
        data: null,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js